/*
 * talk·point — führt die Line-Item-Property "Zustand" (IT#16397) beim
 * Variantenwechsel nach. Gegenstück zum Snippet tp-condition-property:
 * dort werden Startwert + JSON-Map (variant_id -> Label) gerendert.
 *
 * Horizon-nativ (KEIN v1-Empire-Port):
 *  - 'shopify:product:select' (variant-picker.js) bubbelt bis document; das
 *    Ergebnis (neue Varianten-ID) liegt asynchron auf e.promise ->
 *    detail.resource.id. product-form.js aktualisiert beim Variantenwechsel
 *    NUR seine eigenen Refs (variantId, ATC-Button, Menge) — eigene
 *    Hidden-Inputs im Formular bleiben sonst stehen.
 *  - Submit-Sync (Capture-Phase, läuft vor product-form.handleSubmit und
 *    dessen `new FormData(form)`): stellt den Input unmittelbar vor dem
 *    /cart/add auf die tatsächliche [name=id] — deckt Races ab, in denen der
 *    ATC-Klick vor der Promise-Auflösung kommt.
 *  - Der v1-Fetch-Shim (Empire-Chunk-Cache) entfällt: Horizon postet die
 *    FormData nativ, properties[Zustand] funktioniert ohne Nacharbeit.
 *
 * Bewusst import-frei (kein Modul) — keine Abhängigkeit von @shopify/events
 * (gleiches Muster wie tp-add-to-cart.js / tp-addon-modal.js).
 */
(function () {
  'use strict';
  if (window.__tpConditionPropInit) return;
  window.__tpConditionPropInit = true;

  function parseMap(mapEl) {
    try {
      return JSON.parse(mapEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function setProperty(form, map, variantId) {
    var label = variantId ? map[String(variantId)] : null;
    var inp = form.querySelector('input[data-tp-condition]');
    if (label) {
      if (!inp) {
        inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'properties[Zustand]';
        inp.setAttribute('data-tp-condition', '');
        form.appendChild(inp);
      }
      inp.value = label;
    } else if (inp) {
      inp.parentNode.removeChild(inp);
    }
  }

  /* 1) Variantenwechsel: Scope wie product-form.js (Section / Dialog / Card),
     damit auf Grids nur die Formulare der auslösenden Karte angefasst werden. */
  document.addEventListener('shopify:product:select', function (e) {
    if (!e.promise) return;
    var scope =
      (e.target && e.target.closest && e.target.closest('.shopify-section, dialog, product-card')) || document;
    e.promise
      .then(function (r) {
        var d = (r && r.detail) || {};
        // Combined Listing (newProduct): variant-picker morpht 'main' komplett
        // neu — der frisch gerenderte Input ist dann bereits korrekt.
        if (d.newProduct) return;
        var id = d.resource ? d.resource.id : null;
        var maps = scope.querySelectorAll('script[data-tp-condition-map]');
        for (var i = 0; i < maps.length; i++) {
          if (d.productId && maps[i].dataset.productId && maps[i].dataset.productId !== String(d.productId)) continue;
          var form = maps[i].closest('form');
          var map = parseMap(maps[i]);
          if (form && map) setProperty(form, map, id);
        }
      })
      .catch(function () {});
  });

  /* 2) Submit-Sync (Capture): letzter Abgleich mit der tatsächlich gesendeten
     Varianten-ID, bevor product-form.js die FormData einsammelt. */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement) || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      var mapEl = form.querySelector('script[data-tp-condition-map]');
      if (!mapEl) return;
      var map = parseMap(mapEl);
      var idEl = form.querySelector('[name="id"]');
      if (map && idEl) setProperty(form, map, idEl.value);
    },
    true
  );
})();
